import { QuestionCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { useTranslation } from "react-i18next";

export const DateToolTip = () => {
  const { t } = useTranslation();
  return (
    <Tooltip title={t("Date_Tooltip")}>
      <QuestionCircleOutlined />
    </Tooltip>
  );
};
